module.exports = __webpack_public_path__ + "img/fyt_p2.f648d4cb.png";